import { P as Pubsub } from './pubsub-DKqIEqaC.js';
import { f as fetchHTML } from './fetchHTML-9PhJW9Dj.js';
import { N as Notyf } from './notyf-DIw0RvBj.js';

class ProductGrid extends HTMLElement {
  unsubscribers = [];
  html;
  section = this.closest('section');

  connectedCallback() {
    this.sendAnalytics();
    this.unsubscribers.push(
      Pubsub.subscribe('sort:changed', () => this.fetchSection()),
      Pubsub.subscribe('filters:updated', () => this.fetchSection())
    );
  }

  disconnectedCallback() {
    this.unsubscribers.forEach((unsubscriber) => unsubscriber());
  }

  async fetchSection() {
    this.abortController?.abort();
    this.abortController = new AbortController();

    const searchParams = new URLSearchParams(window.location.search);
    let url = `${window.location.pathname}?section_id=${this.id}`;
    if (searchParams.size > 0) url += `&${searchParams}`;

    try {
      this.html = await fetchHTML(url);

      this.replaceGrid();
      this.updateProductCount();
    } catch (error) {
      console.error('Failed to fetch section', error);
      Notyf.error(window.toast_translations.product_grid.fetch_section_error);
    }
  }

  replaceGrid() {
    const fetchedGrid = this.html.querySelector('product-grid');
    this.innerHTML = fetchedGrid.innerHTML;
  }

  updateProductCount() {
    const productCountElement = this.section.querySelector('[data-product-count]');
    const resultsCount = this.html.querySelector('[data-product-count]');

    productCountElement.replaceWith(resultsCount);
  }

  sendAnalytics() {
    const productsJson = [...this.querySelectorAll('[data-product-json]')].map(({ textContent }) =>
      JSON.parse(textContent)
    );

    Shopify.analytics.publish('karl:product_variants', {
      productVariants: productsJson,
    });
  }
}

customElements.define('product-grid', ProductGrid);
